import { type Common } from './common.js';
import type * as ProviderProfile from './models/providerProfile.js';

export class API {
  common: Common;
  baseEndpoint = '/provider-profiles';

  constructor(common: Common) {
    this.common = common;
  }

  async findOneById(providerProfileId: string): Promise<ProviderProfile.ProviderProfile[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${providerProfileId}`);
    return await this.common.getJSON(url);
  }

  async findAll(query: { providerUserId?: string }): Promise<ProviderProfile.ProviderProfile[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}`, query);
    return await this.common.getJSON(url);
  }

  async upsert(
    values: ProviderProfile.BaseProviderProfile
  ): Promise<ProviderProfile.ProviderProfile> {
    const url = this.common.constructPath(`${this.baseEndpoint}`);
    return await this.common.putJSON(url, values);
  }
}
